import { ReactNode } from "react";
import { Box } from "@mui/material";

// A titled group of inputs. A fieldset, so the legend names the group for a
// screen reader as well as on screen; neutral colours only, from the theme.
const FormSection = ({ title, children }: { title: string; children: ReactNode }) => (
  <Box
    component="fieldset"
    sx={{
      border: 1,
      borderColor: "divider",
      borderRadius: 3,
      m: 0,
      mb: 3,
      px: 2,
      pt: 1.5,
      pb: 2,
      minWidth: 0,
      // The dummy's fieldset spaces its children on a 12px rhythm rather than
      // relying on each child to carry its own margin.
      display: "grid",
      gap: 1.5,
    }}
  >
    <Box
      component="legend"
      sx={{
        px: 0.75,
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "text.secondary",
      }}
    >
      {title}
    </Box>
    {children}
  </Box>
);

export default FormSection;
